var render, staticRenderFns
import script from "./SmartIcon.vue?vue&type=script&lang=js"
export * from "./SmartIcon.vue?vue&type=script&lang=js"
import style0 from "./SmartIcon.vue?vue&type=style&index=0&id=ba33271a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports